var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.elementType, {
    ref: _vm.ref,
    tag: "component",
    class: _vm.customClass,
    style: _vm.customStyle,
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "title": _vm.title,
      "id": _vm.id
    },
    on: {
      "click": _vm.clickEvent
    }
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }